import { $themeConfig } from '@themeConfig'

export default function useMimirman() {
  const mimirmanLabel = $themeConfig.app.appMimirmanLabel
  const mimirmanLogoSrc = $themeConfig.app.appMimirmanLogo

  return {
    mimirmanLabel,
    mimirmanLogoSrc
  }
}